import React from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import "./style.css";
import img from "../../resources/logo.webp";
import { host } from "../../config/Config";

export const AdminHaircuts = () => {
  const navigate = useNavigate(); // Initialize navigation
  const [expanded, setExpanded] = React.useState(null);
  const [haircuts, setHaircuts] = React.useState([]);

  React.useEffect(() => {
    const fetchHaircuts = async () => {
      try {
        const response = await fetch(`${host}/api/v1/haircuts`);
        const data = await response.json();
        setHaircuts(data);
      } catch (error) {
        console.error("Error fetching haircuts:", error);
      }
    };

    fetchHaircuts();
  }, []);

  const handleCreate = () => {
    navigate("/admin-haircuts/new")
  }

  const handleExpand = (index) => {
    setExpanded(expanded === index ? null : index);
  };

  return (
    <div className='barber-zajednica-admin-page'>
      <div className='barber-zajednica-admin-haircuts-background'></div>
      <h1>Usluge i Cene</h1>
      <div className='barber-zajednica-admin-haircuts-list'>
        {haircuts.map((haircut, index) => (
          <div
            key={index}
            className={`barber-zajednica-admin-haircuts-list-item ${expanded === index ? 'expanded' : ''}`}
            onClick={() => handleExpand(index)}
          >
            <div className="haircut-info">
              <div>{haircut.name}</div>
              <div>{haircut.price} RSD</div>
            </div>
            {expanded === index && (
              <div className="haircut-details">
                <button className="details-button"
                        onClick={(e) => {
                  e.stopPropagation(); 
                  navigate(`/admin-haircuts/${haircut.id}`); // Navigate to details page
                }}>
                  Prikaži detalje
                </button>
              </div>
            )}
          </div>
        ))}
        <div>
          <button className='barber-zajednica-admin-haircuts-nova-usluga' onClick={handleCreate}>
            Dodaj Novu Uslugu
          </button>
        </div>
      </div>
      <div className="barber-zajednica-admin-logo">
        <img src={img} alt="Logo" />
      </div>
    </div>
  );
};
